"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Activity } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EmpoweringImpactThroughEvidence() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: visualRef,
    isVisible: visualVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="238277" id="unsere-mission" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:32px_32px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20 w-fit mb-8">
              <Activity className="size-4 text-primary" />
              <span className="text-xs font-mono font-medium text-primary uppercase tracking-wider">
                Swiss Precision Philanthropy
              </span>
            </div>
            
            <h1 className="font-default text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-tighter text-foreground">
              Schweizer Präzision trifft auf Krypto-Philanthropie
            </h1>
            
            <p className="mt-6 text-lg sm:text-xl text-muted-foreground max-w-2xl leading-relaxed font-default">
              Crypto4Good revolutioniert das Spendenwesen durch die Verbindung von Schweizer Zuverlässigkeit und modernster Blockchain-Technologie für maximale Transparenz.
            </p>
            
            <div className="mt-3 flex flex-wrap items-center gap-4">
              <Button asChild size="lg" className="h-12 px-8 rounded-lg bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/20">
                <Link to="/FoundationsPage">
                  Für Stiftungen
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="ghost" size="lg" className="h-12 px-8 rounded-lg border border-border hover:bg-accent text-foreground">
                <Link to="/AboutUsPage">
                  Über uns
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={visualRef} className={`lg:col-span-5 relative transition-all duration-1000 delay-200 ease-out ${visualVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative rounded-2xl overflow-hidden border border-border/30 shadow-4xl bg-card aspect-[4/5] lg:aspect-auto lg:h-[600px]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657173/img/swiss_alps_digital_grid.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657173/img/swiss_alps_digital_grid.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657173/img/swiss_alps_digital_grid.png-wvc-sizes" alt="Schweizer Alpen mit digitalem Blockchain-Gitter" className="w-full h-full object-cover opacity-80" loading="lazy" decoding="async" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}